import React from 'react';
import { Snackbar, Alert } from '@mui/material';

let showSnackbarFunc: ((message: string, severity: 'success' | 'error' | 'warning' | 'info', duration?: number) => void) | null = null;

export const showSuccessMessage = (message: string, duration: number = 3000) => {
  if (showSnackbarFunc) {
    showSnackbarFunc(message, 'success', duration);
  }
};

export const showErrorMessage = (message: string, duration: number = 3000) => {
  if (showSnackbarFunc) {
    showSnackbarFunc(message, 'error', duration);
  }
};

export const showWarningMessage = (message: string, duration: number = 3000) => {
  if (showSnackbarFunc) {
    showSnackbarFunc(message, 'warning', duration);
  }
};

export const showInfoMessage = (message: string, duration: number = 3000) => {
  if (showSnackbarFunc) {
    showSnackbarFunc(message, 'info', duration);
  }
};

export default function GlobalSnackbar() {
  const [open, setOpen] = React.useState(false);
  const [message, setMessage] = React.useState('');
  const [severity, setSeverity] = React.useState<'success' | 'error' | 'warning' | 'info'>('info');

  React.useEffect(() => {
    showSnackbarFunc = (msg: string, sev: 'success' | 'error' | 'warning' | 'info' = 'info', duration: number = 3000) => {
      setMessage(msg);
      setSeverity(sev);
      setOpen(true);
    };
  }, []);

  const handleClose = (event: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  return (
    <Snackbar
      open={open}
      autoHideDuration={3000}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert
        onClose={handleClose}
        severity={severity}
        variant="filled"
        sx={{ width: '100%' }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
}
